/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';
import { Link } from 'react-router-dom';
import moment from 'moment';

import AppTable from 'components/appTable';
import PanelBoxLayout from 'components/layout/panelBox';
import { useActions } from 'common/hooks/useActions';
import { RejectReasonOwnerType } from 'common/enums';

import * as S from './styles';
import * as T from 'common/types';

interface IProps {
  menuList: { list: T.Pages.CafeteriaListItem[]; totalPages: number };
  loading: boolean;
}

export default function TeaboyReasonsTable({ menuList, loading }: IProps) {
  const { rejectReasonsListRequestAction } = useActions();
  const [meta] = useState({
    keyword: '',
    ownerType: RejectReasonOwnerType.teaboy
  });

  const fetchData = () => {
    rejectReasonsListRequestAction(meta);
  };

  useEffect(() => {
    fetchData();
  }, [meta]);

  return (
    <S.Content>
      <PanelBoxLayout>
        <AppTable
          headers={[
            { id: 1, title: 'ID', dir: 'left', width: '5%' },
            { id: 3, title: 'Title', dir: 'left', width: '35%' },
            { id: 4, title: 'CreatedAt', dir: 'left', width: '15%' },
            { id: 4, title: 'UpdatedAt', dir: 'left', width: '15%' },
            { id: 4, title: 'Status', dir: 'left', width: '25%' },
            { id: 7, title: 'Edit', width: '5%' }
          ]}
          style={{ minWidth: 'auto' }}
          data={menuList?.list}
          loading={loading}
          altanfeethiFields={{
            id: (item: T.Pages.RejectReasons) => <S.Div className="text-left">{item?.id}</S.Div>,
            title: (item: T.Pages.RejectReasons) => (
              <S.Div className="text-left captal">
                {item?.reasonTranslations.map((item) => item.language === 'en' && item.translate)}
              </S.Div>
            ),

            CreatedAt: (item: T.Pages.RejectReasons) => (
              <S.Div className="text-left">{moment(item?.createdAt).format('YYYY.MM.DD HH:mm')}</S.Div>
            ),
            UpdatedAt: (item: T.Pages.RejectReasons) => (
              <S.Div className="text-left">{moment(item?.updatedAt).format('YYYY.MM.DD HH:mm')}</S.Div>
            ),
            status: (item: T.Pages.RejectReasons) => (
              <S.Div className="text-left" style={{ color: item?.isActive ? '#1DBAAF' : '#FF6464' }}>
                {item?.isActive ? 'Active' : 'InActive'}
              </S.Div>
            ),
            edit: (item: T.Pages.RejectReasons) => (
              <S.Div style={{ cursor: 'pointer' }}>
                <Link to={`/panel/cafeteria/teaboy-cancelled-reason/${item?.id}`}>
                  <ReactSVG
                    src="/icons/stroke/pen-card.svg"
                    beforeInjection={(svg) => {
                      svg.setAttribute('stroke', `#8A93AC`);
                    }}
                  />
                </Link>
              </S.Div>
            )
          }}
        />
      </PanelBoxLayout>
    </S.Content>
  );
}
